// Section-marker labels rendered on the homepage (SectionMarker index + label).
const home = {
  sections: {
    about: 'About',
    experience: 'Experience',
    projects: 'Projects',
    contact: 'Contact',
  },
};

export default home;
